import * as React from "react";
const SvgZone20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M1 2h18v16H1V2Zm2 2v5h6V4H3Zm14 7h-6v5h6v-5Zm-8 5v-5H3v5h6Z",
      clipRule: "evenodd"
    })
  );
export default SvgZone20Px;
